import React from 'react';

const Logo = () => (
  <div>
    <img src="/image/logo-ag2r-header.svg" style={{ height: '70px' }} alt="logo"/>
  </div>
);

export default Logo;
